// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1nExb","messages":"Chat_messages__1Esoq","dateDivider":"Chat_dateDivider__2m56n"};